module.exports = __webpack_public_path__ + "static/media/pin_logo.0fd8ca13.png";